import { useOutdatedContacts } from "@/entities/notification/api";
import { Button } from "@/shared/ui/button";
import { Spinner } from "@/shared/ui/spinner";

export const ContactsOutdatedButton = () => {
  const { mutateAsync, isPending } = useOutdatedContacts();

  const handleOutdated = () => {
    mutateAsync();
  };

  return (
    <Button
      className="w-full"
      variant="destructive"
      onClick={handleOutdated}
      disabled={isPending}
    >
      {isPending ? <Spinner /> : "Контакты устарели"}
    </Button>
  );
};
